import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';
import { types as actions, setZonesBySiteAction } from '../../reducers/actions';
import { ZoneService } from '../../services';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.GET_ZONES_BY_SITE),
    switchMap(action =>
      ZoneService.getBySiteId(action.siteId, store).pipe(
        map(data => setZonesBySiteAction(data)),
        catchError(retryAuthentication(action$, 'epics/zones/getZonesBySite'))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/zones/getZonesBySite.js